import classNames from 'classnames';
import React, { ImgHTMLAttributes } from 'react';
import { Nav } from 'react-bootstrap';

interface HeaderBuilderProps {
  children?: React.ReactNode;
  className?: string;
}

//
// HeaderBuilder
//

const HeaderBuilder = ({ className, ...props }: HeaderBuilderProps) => {
  const classes = classNames('header', className);

  return <header className={classes} {...props} />;
};

//
// Header avatar top
//

// Header.AvatarTop = React.forwardRef(({ className, ...props }: any, ref) => {
//   const classes = classNames("header-avatar-top", className);

//   return <Avatar className={classes} ref={ref} {...props} />;
// });

//
// Header body
//

HeaderBuilder.Body = ({ className, ...props }: HeaderBuilderProps) => {
  const classes = classNames('header-body', className);

  return <div className={classes} {...props} />;
};

//
// HeaderBuilder footer
//

HeaderBuilder.Footer = ({ className, ...props }: HeaderBuilderProps) => {
  const classes = classNames('header-footer', className);

  return <div className={classes} {...props} />;
};

//
// HeaderBuilder image top
//

HeaderBuilder.ImageTop = ({ className, alt, ...props }: ImgHTMLAttributes<HTMLImageElement>) => {
  const classes = classNames('header-img-top', className);

  return <img className={classes} alt={alt} {...props} />;
};

//
// HeaderBuilder pretitle
//

HeaderBuilder.Pretitle = ({ className, children, ...props }: HeaderBuilderProps) => {
  const classes = classNames('header-pretitle', className);

  return (
    <h6 className={classes} {...props}>
      {children}
    </h6>
  );
};

//
// HeaderBuilder subtitle
//

HeaderBuilder.Subtitle = ({ className, ...props }: HeaderBuilderProps) => {
  const classes = classNames('header-subtitle', className);

  return <p className={classes} {...props} />;
};

//
// HeaderBuilder tabs
//

HeaderBuilder.Tabs = ({ className, ...props }: HeaderBuilderProps) => {
  const classes = classNames('header-tabs', className);

  return <Nav variant="tabs" className={classes} {...props} />;
};

//
// HeaderBuilder title
//

HeaderBuilder.Title = ({ className, children, ...props }: HeaderBuilderProps) => {
  const classes = classNames('header-title', className);

  return (
    <h1 className={classes} {...props}>
      {children}
    </h1>
  );
};

export default HeaderBuilder;
